<template>
  <div id="grid-admin">
    <div v-if="loading">
      <loading></loading>
    </div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-data-table
            :headers="headers"
            :items="administrativo"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.periodo }}</td>
              <td class="text-xs-left">{{ props.item.asunto }}</td>
              <td class="text-xs-left">{{ props.item.filename }}</td>
              <td class="text-xs-left">{{ props.item.fecha_creacion }}</td>
              <td class="text-xs-left">{{ props.item.usuario }}</td>
              <v-btn
                v-if="
                  props.item.filename != null &&
                  props.item.filename != '' &&
                  props.item.filename !== undefined
                "
                depressed
                outline
                icon
                fab
                dark
                color="primary"
                small
                @click="downloadFile(props.item.id, props.item.filename)"
              >
                <v-icon>cloud_download</v-icon>
              </v-btn>
              <!-- <v-btn
                v-if="(usuarioLoggedTipe == 'AGENCIA' || usuarioLoggedTipe == 'ADMINISTRADOR')"
                depressed
                outline
                icon
                fab
                dark
                color="red"
                small
                @click="dialogDeleteFile(props.item.id)"
              >
                <v-icon>clear</v-icon>
              </v-btn> -->
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA PROVEEDORES -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <div class="text-xs-center">
              <td>
                <template>
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    title="Descargar documento"
                    icon
                    fab
                    dark
                    color="primary"
                    small
                  >
                    <v-icon>cloud_download</v-icon> </v-btn
                  >Descargar documento
                </template>
              </td>
              <td>
                <template>
                  <v-btn v-if="getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
                    class="btn-sigas"
                    depressed
                    outline
                    title="Eliminar documento"
                    icon
                    fab
                    dark
                    color="red"
                    small
                  >
                    <v-icon>clear</v-icon> </v-btn
                  >Eliminar Documento
                </template>
              </td>
            </div>
          </v-card-actions>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
      <v-dialog v-model="dialogEliminar" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">¿Esta seguro?</v-card-title>
          <v-card-text
            >¿Esta seguro que desea eliminar ese archivo?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="dialogEliminar = false"
              >Cancelar</v-btn
            >
            <v-btn color="green darken-1" flat @click="deleteFile()"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import { misMixins } from "@/mixins/myMixing.js";
import jwtDecode from "jwt-decode";

export default {
  name: "grid-admistrativo",
  components: {
    LoadingDescarga,
    Loading,
  },
  mixins: [misMixins],
  props: {
    tipeView: "",
  },
  data() {
    return {
      idFile: "",
      dialogLoading: false,
      dialogEliminar: false,
      loading: false,
      dialog: false,
      fechaVisita: new Date().toISOString().substr(0, 10),
      menu1: false,
      idVisitaUpdate: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      headers: [
        { text: "Periodo", sortable: false, value: "periodo" },
        { text: "Asunto", sortable: false, value: "asunto" },
        {
          text: "Documento",
          align: "left",
          sortable: false,
          value: "filename",
        },
        { text: "Fecha", sortable: false, value: "fecha" },
        { text: "Usuario", sortable: false, value: "usuario" },
        {
          text: "Accion",
          sortable: false,
          value: "",
        },
      ],
      administrativo: [],
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },

  mounted() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.contratoId = this.$store.getters.contratoStored;
  },
  created() {
    this.loadDataAdministracion();
  },

  computed: {},
  methods: {
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      // console.log("DEVODED USER:", user);
      return user.perfil.codigo;
    },
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.idContrato === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    async loadDataAdministracion() {
      this.loading = true;
      this.administrativo = await this.loadAdminAll();
      this.loading = false;
      if (this.administrativo.length > 0) {
        this.$parent.alerta = false;
      } else {
        this.$parent.alerta = true;
      }
    },

    async loadAdminAll() {
      let that = this;
      //let subProceso = this.$store.getters.subProTabSelectedStored;
      //let idContrato = this.$store.getters.contratoStored;

      return await axios
        .get("/infocontractual/findAllProceso")
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    dialogDeleteFile(id) {
      this.dialogEliminar = true;
      this.idFile = id;
    },

    async deleteFile() {
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        id: this.idFile,
        idContrato: idContrato,
        subProceso: this.proceso,
      };

      axios
        .put("/administracion/delete", this.body)
        .then((response) => {
          this.loadDataAdministracion();
          this.dialogEliminar = false;
        })
        .catch((response) => {
          this.loadDataAdministracion();
          this.dialogEliminar = false;
        });
      this.loading = false;
      reloadGrid();
    },
    //POST ,  BODY IDCONTRATO,FILENAME
    async downloadFile(id, filename) {
      this.dialogLoading = true;
      let that = this;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        fileName: filename,
        id: id,
      };
      return await axios
        .post("/infocontractual/download", this.body, { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    reloadGrid() {
      this.dialog = false;
      this.$parent.reloadAdmin();
    },
  },
};
</script>